import { swalMessages } from '@auteco/constants'
import React, {useState, useEffect} from 'react'
import EmailsPage from "src/pages/Trakku/EmailsPage/EmailsPage"
import {getRecipients, updateEmailRecipient} from 'src/services/trakkuServices'
import swal from 'sweetalert'

const EmailsContainer = () => {
  const [recipients, setRecipients] = useState([])
  const fetchRecipients = async() => {
    const { data} = await getRecipients()
    if (data) {
      setRecipients(data)
    }else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const handleUpdateEmail = async (params) => {
    const body = {
      CODIGO_PUNTO_VENTA: params.CODIGO_PUNTO_VENTA,
      CORREO: params.CORREO
    }
    const response = await updateEmailRecipient(body)
    if (response.success === 1) {
      const newRecipients = recipients.map(value => value.CODIGO_PUNTO_VENTA === params.CODIGO_PUNTO_VENTA ? {...value,
      CORREO:params.CORREO} : value)
      setRecipients(newRecipients)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }
  useEffect(() => {
    fetchRecipients()
  }, [])
  return (
    <EmailsPage info={recipients} onUpdateEmail={handleUpdateEmail}/>
  )
}

export default EmailsContainer